import { currencyByCountry, getLocalStorage, isIn, isMobile, isValidUser } from 'helpers/Helper';
import { HelperConstant } from 'helpers/HelperConstant';
import { getDecodedAccessToken } from 'helpers/TokenHelper';
import { useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import { ICategoryModel } from 'models/CategoryList.Model';
import { IThresholdCategoryModel } from 'models/ThresholdCategory.Model';
import { IGetVariantModal, IProductVariantModel, IproductValue } from 'models/productvalue.Model';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import MasterService from 'services/Master.Service';
import ProductTypeService from 'services/ProductType.Service';
import UpdateModelVariantsService from 'services/UpdateModelVariants.Service';
import { CustomDropdown } from 'components/shared/CustomDropdown';
import { CustomToaster } from 'components/shared/CustomToaster';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomButton } from 'components/shared/CustomButton';
import { CustomRadioGroup } from 'components/shared/CustomRadioGroup';
import { CustomCheckBox } from 'components/shared/CustomCheckBox';
import { CustomDatePicker } from 'components/shared/CustomDatePicker';
import moment from 'moment';

function ProductValue() {

    const [showModal, setShowModal] = useState(false);
    const [ModelDropDownData, setModelDropDownData] = useState<Array<any>>([]);
    const [ProductList, setProductList] = useState<Array<any>>([]);
    const [Brand, setBrand] = useState<Array<any>>([]);
    const [BrandModel, setBrandModel] = useState<Array<IproductValue>>([]);
    const [Series, setSeriesModel] = useState<Array<IproductValue>>([]);
    const [BrandId, setBrandId] = useState<any>();
    const [ModelId, setModelId] = useState<any>();
    const [SeriesId, setSeriesId] = useState<any>();
    const [ProductType, setProductType] = useState<any>();
    const [ModelVarientedit, setModelVarientedit] = useState<Array<IproductValue>>([]);
    
    const [UpdateModelVarient, setUpdateModelVarient] = useState<IproductValue>(
        {
            Id: 0,
            Created: "2022-04-25T11:12:41.409Z",
            CreatedBy: 0,
            Active: true,
            Modified: "2022-04-25T11:12:41.409Z",
            ModifiedBy: 0,
            ValidationErrors: {},
            Name: "string",
            ThumbnailPath: "string",
            RowOrder: 0,
            Variants: [],
        }
    );

    const [CategoryId, setCategoryId] = useState<number>(0);
    const [showToast, setShowToast] = useState(false);
    const [showToastPrice, setShowToastPrice] = useState(false);
    const [notFound, setNotFound] = useState(false);
    // const [thresholdCategoryId, setThresholdCategoryId] = useState<number>();

    const [categoryList, setCategoryList] = useState<Array<ICategoryModel>>([]);
    const [thresholdCategoryList, setThresholdCategoryList] = useState<Array<IThresholdCategoryModel>>([]);
    const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
    const [advfilterValue, setAdvFilterValue] = useState<any>('');
    const [searchText, setSearchText] = useState('');

    let isTablet = useTypedSelector(state => state.FindDevice.isTablet);

    const ProductTypeServicesData = () => {
        ProductTypeService.GetList().then(res => {
            if (res.status === 200) {
                setProductList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetProductCategoryList = () => {
        MasterService.GetProductCategory().then(res => {
            if (res.status === 200) {
                setCategoryList(res.data);
                setCategoryId(res.data[0].Id);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetProductThresholdValue = (productTypeId : any) => {
        MasterService.GetProductThresholdValue(productTypeId).then(res => {
            if (res.status === 200) {
                setThresholdCategoryList(res.data);
               
                // setThresholdCategoryId(res.data[0].Id);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    useEffect(() => {
        isValidUser(getDecodedAccessToken(getLocalStorage().Token));
        ProductTypeServicesData();
        GetProductCategoryList();
    }, []);

    const onChangeCategory = (e: any) => {
        const selectedValue = e.target.value;
        setCategoryId(parseInt(selectedValue));
        setProductList([]);
        setProductType([]);
        setBrand([]);
        setModelDropDownData([]);
        setBrandModel([]);
        setSeriesModel([])
        setSeriesId("");
        ProductTypeServicesData();
        // if (SeriesId > 0) {
        //     GetSeriesData(SeriesId, selectedValue);
        // }
    }

    const GetBrandMasterByProductId = (productTypeId: number) => {
        setBrandModel([]);
        setBrand([]);
        setSeriesModel([]);
        setModelDropDownData([]);
        if(searchText!='') setSearchText('');
        MasterService.GetBrandMasterByProductId(productTypeId, HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setBrand(res.data);
                setProductType(productTypeId);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const GetBrands = (BrandId: any, category?: any) => {
        setSeriesModel([]);
        setModelDropDownData([]);
        setBrandId(parseInt(BrandId));
        if(searchText!='') setSearchText('');
        let categoryData = category > 0 ? category : CategoryId;

        let reqData: IGetVariantModal = {
            offsetStart: null,
            rowsPerPage: null,
            sortOrder: sortOrder,
            sortOrderColumn: 'MaximumValue',
            searchText: '',
            isPublic: '',
            brandMasterId: parseInt(BrandId),
            categoryId: parseInt(categoryData)
        }

        UpdateModelVariantsService.GetVariantsv1(reqData).then(res => {
            if (res.status === 200) {
                setSeriesModel(res.data);
                setSeriesId("");
            }
        }).catch(e => {
            console.log(e);
        });
    }


    const GetSeriesData = (SeriesId: any, category?: any) => {
  
        setModelDropDownData([]);
        setSeriesId(parseInt(SeriesId));
        if(searchText!='') setSearchText('');
        let categoryData = category > 0 ? category : CategoryId;

        let reqData: IGetVariantModal = {
            offsetStart: null,
            rowsPerPage: null,
            sortOrder: sortOrder,
            sortOrderColumn: 'MaximumValue',
            searchText: '',
            isPublic: '',
            brandSeriesId: parseInt(SeriesId),
            categoryId: parseInt(categoryData)
        }

        UpdateModelVariantsService.GetVariantsv1(reqData).then(res => {
            if (res.status === 200) {
                setBrandModel(res.data);
                setModelId("");
                setModelDropDownData(res.data);
                setSearch(res.data);
                setNotFound(false);
            }
        }).catch(e => {
            console.log(e);
        });
    }


    const GetModelData = (seriesModelId: any) => {

        if(searchText!='') setSearchText('');
        let reqData: IGetVariantModal = {
            offsetStart: null,
            rowsPerPage: null,
            sortOrder: sortOrder,
            sortOrderColumn: 'MaximumValue',
            searchText: '',
            isPublic: '',
            brandMasterId: null,
            categoryId: CategoryId,
            brandSeriesId: parseInt(SeriesId),
            seriesModelId: parseInt(seriesModelId)
        }
        // "", seriesModelId, ProductType, CategoryId
        UpdateModelVariantsService.GetVariantsv1(reqData).then(res => {
            if (res.status === 200) {
                setBrandModel(res.data);
                setModelId(parseInt(seriesModelId));
                setNotFound(false);
            }
        }).catch(e => {
            console.log(e);
        });
    }


    const GetVariantsBySortOrder = (el: string) => {
        const splitedValue = el.split(',');

        let reqData: IGetVariantModal = {
            offsetStart: null,
            rowsPerPage: null,
            sortOrder: splitedValue[1],
            sortOrderColumn: splitedValue[0],
            searchText: '',
            isPublic: '',
            brandSeriesId: SeriesId,
            brandMasterId: null,
            seriesModelId: ModelId,
            categoryId: CategoryId
        }

        UpdateModelVariantsService.GetVariantsv1(reqData).then(res => {
            if (res.status === 200) {
                setBrandModel(res.data);
                setModelId("");
                setModelDropDownData(res.data);
                setSearch(res.data);
            }
            if (res.status == 204) {
                setNotFound(true);
            }
        }).catch(e => {
            console.log(e);
        });
    }
    const getData =() =>{
        setShowModal(false);
        GetSeriesData(SeriesId);
       
    }

    const UpdateModelVarients = (BrandId: any) => {
        let bPrice = true;
        if (UpdateModelVarient.Variants.length > 0) {
            UpdateModelVarient.Variants.forEach(element => {
                let minValue = parseFloat(element.MinimumValue);
                let maxValue = parseFloat(element.MaximumValue);

                if (element.MinimumValue === null || element.MinimumValue === "" || element.MaximumValue === null || element.MaximumValue === "") {
                    bPrice = false;
                    return setShowToastPrice(true);
                }
                if (maxValue < minValue) {
                    bPrice = false;
                    return setShowToast(true);
                }
            });
            if (bPrice) {
                UpdateModelVariantsService.UpdateModelVarients(UpdateModelVarient).then((res) => {
                    if (res.status === 200) {
                        setShowModal(false);
                       
                        UpdateModelVarient.Variants = [];
                        if (BrandId !== "") {
                            setTimeout(() => { GetSeriesData(SeriesId) }, 3000);
                        }
                        if (BrandId === "") {
                            GetModelData(ModelId);
                        }
                    }

                }).catch(e => {
                    console.log(e);
                });
            }
        }
    }


    const onChangeCategoryHandler = (variants: IProductVariantModel[], value: any, type: "productCategoryName" | "thresholdCategoryName") => {
        const updatedVariants = variants.map(variant => {
            if (type === "productCategoryName") {
                variant.ProductCategoryId = value;
                const category = categoryList.find(cat => cat.Id === parseInt(value));
                if (category) {
                    variant.ProductCategoryName = category.Name;
                }
            } else if (type === "thresholdCategoryName") {
                variant.ThresholdCategoryId = value;
                const thresholdCategory = thresholdCategoryList.find(thresh => thresh.Id === parseInt(value));
                if (thresholdCategory) {
                    variant.ThresholdCategoryName = thresholdCategory.Name;
                }
            }
            return variant;
        });

        setUpdateModelVarient(prevState => ({
            ...prevState,
            Variants: updatedVariants
        }));
    };

    //priceUpdate function
    const priceUpdate = (item: IProductVariantModel, value: any, Id: any, type: "minValue" | "maxValue" | "productCategoryName" | "thresholdCategoryName") => {
        if (type === "minValue") {
            //if (value > item.MaximumValue) { return setShowToast(true); }
            let fIndex = UpdateModelVarient.Variants.findIndex(it => it.Id === item.Id);
            if (fIndex >= 0) {
                // UpdateModelVarient.Id = Id;
                item.MinimumValue = value;
                UpdateModelVarient.Variants[fIndex] = item;
            }
            else {
                item.MinimumValue = value;
                UpdateModelVarient.Variants.push(item);
            }
        }
        if (type === "maxValue") {
            //if (value < item.MinimumValue) { return setShowToast(true); }
            let fIndex = UpdateModelVarient.Variants.findIndex(it => it.Id === item.Id);
            if (fIndex >= 0) {
                // UpdateModelVarient.Id = Id
                item.MaximumValue = value;
                UpdateModelVarient.Variants[fIndex] = item;
            }
            else {
                item.MaximumValue = value;
                UpdateModelVarient.Variants.push(item);
            }
        }
    }

    const changeDisplyList = (value: any, result: any) => {
        if (value) {
            value.DisplayInList = result;
            let index = UpdateModelVarient.Variants.findIndex(item => item.Id === value.Id);
            index >= 0 ? UpdateModelVarient.Variants[index] = value : UpdateModelVarient.Variants.push(value);
        }
    }

    const changeRestrictedStatus = (value: any, result: any) => {
        if (value) {
            value.IsRestricted = result;
            let index = UpdateModelVarient.Variants.findIndex(item => item.Id === value.Id);
            index >= 0 ? UpdateModelVarient.Variants[index] = value : UpdateModelVarient.Variants.push(value);
        }
    }

    const screenRefresh = () => {
        window.location.reload();
    }

    const [Search, setSearch] = useState([]);

    const handleFilter = (text: any) => {
        if (text !== '') {
            const newData: any = BrandModel.filter((item) => {
                return Object.values(item).join('').toLowerCase().includes(text.toLowerCase())
            });
            setBrandModel(newData);
        } else {
            setBrandModel(Search);
        }
    };

    const editHandler = (val:IproductValue) => {
        setModelVarientedit([val]);
        setShowModal(true);
        GetProductThresholdValue(val?.Variants[0]?.ProductTypeId)
       
    }

    const advanceFilter = [
        {
            Name: 'Last Modified',
            value: 'modified,desc'
        },
        {
            Name: 'Last Added',
            value: 'created,desc'
        },
        {
            Name: 'Ascending',
            value: 'seriesModelName,asc'
        },
        {
            Name: 'Descending',
            value: 'seriesModelName,desc'
        },
        {
            Name: 'Low to High (Price)',
            value: 'maximumValue,asc'
        },
        {
            Name: 'High to Low (Price)',
            value: 'maximumValue,desc'
        },
    ]

    const GetVariants = (pageNumber: any, searchText?: any) => {
        let reqData: IGetVariantModal = {
            offsetStart: pageNumber,
            rowsPerPage: null,
            sortOrder: sortOrder,
            sortOrderColumn: 'MaximumValue',
            searchText: searchText,
            isPublic: '',
            // brandMasterId: BrandId,
            categoryId: CategoryId,
            brandSeriesId: SeriesId,
            seriesModelId: ModelId
        }

        // "", seriesModelId, ProductType, CategoryId
        UpdateModelVariantsService.GetVariantsv1(reqData).then(res => {
            if (res.status === 200) {
                setBrandModel(res.data);
                setNotFound(false)
            }
            if (res.status === 204) {
                setNotFound(true)
            }
        }).catch(e => {
            console.log(e);
        });
    }

    useEffect(() => {
        if (searchText) {
            GetVariants(null, searchText);
        }
    }, [searchText])

    const handleStartDateChange = (e, item) => {
        const fIndex = UpdateModelVarient.Variants.findIndex(x => x.Id == item.Id);
        const newDate = moment(e.target.value).format('YYYY-MM-DD');

        if (fIndex >= 0) {
            item.StartDate = newDate;
            UpdateModelVarient.Variants[fIndex] = item;
        }
        else {
            item.StartDate = newDate;
            UpdateModelVarient.Variants.push(item);
        }

    };

    const handleEndDateChange = (e, item) => {
        const fIndex = UpdateModelVarient.Variants.findIndex(x => x.Id == item.Id);
        const newDate = moment(e.target.value).format('YYYY-MM-DD');

        if (fIndex >= 0) {
            item.EndDate = newDate;
            UpdateModelVarient.Variants[fIndex] = item;
        }
        else {
            item.EndDate = newDate;
            UpdateModelVarient.Variants.push(item);
        }
    };

    return (
        <div className="page-content">
            <Container fluid className="p-0">
                <div>
                    <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>PRODUCT PRICE LIST</h5>
                </div>
                <Row>
                    <Col xl='3'>
                        <Card>
                            <Row className="">
                                <Col xs="12">
                                    <Row>
                                        <Col lg="12" xl="12" xs="12">
                                            <div className='mb-2'>
                                                <i className='fa fa-cog me-2 align-middle '></i>
                                                <span className='m-0 text-dofy fw-semibold'>CATEGORIES</span>
                                            </div>
                                        </Col>
                                        <Col lg="6" xl="12" xs="12">
                                            <CustomRadioGroup className='justify-content-around' data={categoryList} value={"Id"} defaultValue={CategoryId} displayName={'Name'} direction={'vertical'} onChange={onChangeCategory} id={'categoryfilter'} />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col size="12">
                                    <Row>
                                        <Col xs="12" md="12">
                                            <CustomDropdown label={"Gadget"} data={ProductList} onChange={(e: any) => GetBrandMasterByProductId(e.target.value)} displayField='DisplayName' valueField='Id' id={undefined} value={undefined} error={undefined} />
                                        </Col>
                                        <Col xs="12" md="12">
                                            <CustomDropdown label={"Brand"} data={Brand} onChange={(e: any) => GetBrands(e.target.value)} displayField='DisplayName' valueField='Id'
                                                disabled={!(Brand.length > 0)} id={undefined} value={undefined} error={undefined} />
                                        </Col>
                                        <Col xs="12" md="12">
                                            <CustomDropdown label={"Series"} data={Series} onChange={(e: any) => GetSeriesData(e.target.value)} displayField='Name' valueField='Id'
                                                disabled={!(Series.length > 0)} id={undefined} value={undefined} error={undefined} />
                                        </Col>
                                        <Col xs="12" md="12">
                                            <CustomDropdown label={"Model"} data={ModelDropDownData} onChange={(e: any) => GetModelData(e.target.value)} displayField='Name' valueField='Id'
                                                disabled={!(BrandModel.length > 0)} id={undefined} value={undefined} error={undefined} />
                                        </Col>
                                        {/* <Col xs="12" md="3">
                                                <CustomDropdown label={"Price"} data={sortingFilter} onChange={(e: any) => GetVariantsBySortOrder(e.target.value)} displayField='Name' valueField='sortOrder' id={undefined} value={undefined} error={undefined} />
                                            </Col> */}
                                        {(SeriesId && BrandModel.length > 0) ?
                                            <Col xs="12">
                                                <Row>
                                                    <Col lg="12" xl="12" xs="12">
                                                        <div className='my-3'>
                                                            <i className='fa fa-cog me-2 align-middle'></i>
                                                            <span className='m-0 text-dofy fw-semibold'>ADVANCE FILTERS</span>
                                                        </div>
                                                    </Col>
                                                    <Col lg="6" xl="12" xs="12">
                                                        <CustomRadioGroup className='justify-content-around' data={advanceFilter} value={"value"} defaultValue={advfilterValue} displayName={'Name'} direction={'vertical'} onChange={(e) => GetVariantsBySortOrder(e.target.value)} id={'advancefilter'} />
                                                    </Col>
                                                </Row>
                                            </Col> : <></>}
                                        <Col xs="12" md="12" style={{ marginTop: "40px" }} className='text-center d-flex'>
                                            <CustomButton onClick={() => screenRefresh()} type={'button'} btnClassName={'btn-warning'} iconClasssName={undefined} name={'Reset'} />
                                            {/* <CustomButton onClick={() => window.location.href = "/product-value"} type={'button'} btnClassName={'btn-success mx-2'} iconClasssName={undefined} name={'Add Product'} /> */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col xl='9'>
                        {(SeriesId && BrandModel.length > 0) ?
                            <Row>
                                <div className="search-box mb-2 me-2">
                                    <div className="position-relative">
                                        <input
                                            type="search"
                                            name='search'
                                            className="form-control bg-light border-light rounded"
                                            placeholder="Search..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <i className="bx bx-search-alt search-icon"></i>
                                    </div>
                                </div>
                                {!notFound ? <>
                                    {BrandModel.map((val, i) => {
                                        return (
                                            <Col md='12' key={i}>
                                                <Card >
                                                    <CardBody className='p-0'>
                                                        <Row className='justify-content-between'>
                                                            <Col xl='12'>
                                                                <div className='d-flex justify-content-between'>
                                                                    <p className='fw-semibold m-0 text-dofy'>{val.Variants[0].SeriesModelName} </p>
                                                                    <i className='bx bx-edit-alt cursor-pointer fs-5' onClick={() => editHandler(val)}></i>
                                                                </div>
                                                            </Col>
                                                            <Col xl='12'>
                                                                <div className='d-flex justify-content-between my-1'>
                                                                    <p className='my-1 text-muted'>{val.Variants[0].ProductCategoryName} </p>
                                                                    <p className='my-1'>{val.Variants[0].ThresholdCategoryName} </p>
                                                                    <p className='my-1'>{val.Variants[0].OSTypeName} </p>

                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="row py-2 px-1">
                                                            {val.Variants.map((items, idx) => (
                                                                <div key={idx} className={`${isMobile() ? 'col-12' : 'col'} text-center mb-2`}>
                                                                    <h6 className='variant-in-center'>
                                                                        <span className='text-dofy p-1 text-nowrap m-0'>{items.Name}</span>
                                                                    </h6>
                                                                    <p className='my-1 fw-semibold text-danger'>
                                                                        Min : {currencyByCountry(items.MinimumValue)}
                                                                    </p>
                                                                    <p className='my-1 fw-semibold text-success'>
                                                                        Max : {currencyByCountry(items.MaximumValue)}
                                                                    </p>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        )
                                    })}
                                </> :
                                    <Row className='my-5'>
                                        <Col xl={12} className='text-center'>
                                            <i className='bx bxs-devices dofy-admin-font-lg text-dofy'></i>
                                            <h5 className='m-2 text-dofy fw-semibold'>No Records Found</h5>
                                        </Col>
                                    </Row>
                                }
                            </Row> :
                            <Row className='my-5'>
                                <Col xl={12} className='text-center'>
                                    <i className='bx bxs-devices dofy-admin-font-lg text-dofy'></i>
                                    <h5 className='m-2 text-dofy fw-semibold'>Choose criteria to view Products and its values</h5>
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
                {/* <Row>
                    <Col xl="12" md="12" className=''>
                        {BrandModel.length > 0 ?
                            <CustomDataTable data={BrandModel} columns={columns}
                                isPagination={false}
                                customPageSize={undefined}
                                isActionEdit={true}
                                isActionDelete={false}
                                editHandler={editHandler}
                                isGlobalFilter={true}
                                searchHandler={handleFilter}
                                canShowButton1={false}
                                canShowButton2={false}
                                deleteHandler={undefined}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={''}
                                specialGrid={true}
                                recordsCount={BrandModel.length}
                                                        />
                            :
                            <CustomDataTable data={[]} columns={columns}
                                isPagination={false}
                                customPageSize={undefined}
                                isActionEdit={true}
                                isActionDelete={false}
                                editHandler={editHandler}
                                isGlobalFilter={true}
                                searchHandler={handleFilter}
                                canShowButton1={false}
                                canShowButton2={false}
                                deleteHandler={undefined}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={''}
                                pageSize={50}
                                recordsCount={BrandModel.length}
                                sortOrder={[{
                                    desc: true
                                }]}
                            />
                        }
                    </Col>
                </Row> */}
                <Row>
                    {ModelVarientedit?.map((Model, index) => {
                        return (
                            <Modal key={index} isOpen={showModal} toggle={() => setShowModal(false)}
                                centered size='xl'>
                                <ModalHeader toggle={() => setShowModal(false)}>{Model.Variants[0].SeriesModelName}</ModalHeader>
                                <Row className='p-3'>
                                    <Col lg="6" xl="6" md="6" sm="12" xs="12">
                                        <CustomDropdown label={"Product Category"} id={undefined} value={Model.Variants[0].ProductCategoryId} data={categoryList} error={undefined}
                                            onChange={(e) => onChangeCategoryHandler(Model.Variants, e.target.value, "productCategoryName")} displayField='Name' valueField='Id' />
                                    </Col>
                                    <Col lg="6" xl="6" md="6" sm="12" xs="12">
                                        <CustomDropdown label={"Threshold Category"} id={undefined} value={Model.Variants[0].ThresholdCategoryId} data={thresholdCategoryList} error={undefined}
                                            disabled={true}  displayField='Name' valueField='Id' />
                                    </Col>
                                </Row>
                                <ModalBody>
                                    <Row className='p-3'>
                                        {Model.Variants?.map((item, index) => {
                                            return (
                                                <Col key={index} lg="3" md="6" xl="3" xs="12" sm="12" className='text-center'>
                                                    {isIn() ?
                                                        <Card color="#eee" className='p-2'>
                                                            <CardHeader color="light">
                                                                {item.Name}
                                                            </CardHeader>
                                                            <div className='row pt-3'>
                                                                <div className="col-7 text-start">
                                                                    <h6 className='mt-2'>₹ MIN</h6>
                                                                </div>
                                                                <div className="col-5 text-end">
                                                                    <CustomTextBox type={"number"} label={undefined} id={undefined} error={undefined} defaultValue={item.MinimumValue} onChange={(e) => priceUpdate(item, e.target.value, Model.Id, "minValue")} />
                                                                </div>
                                                            </div>
                                                            <div className='row pt-3'>
                                                                <div className="col-7 text-start">
                                                                    <h6 className='mt-2'>₹ MAX</h6>
                                                                </div>
                                                                <div className="col-5 text-end">
                                                                    <CustomTextBox type={"number"} label={undefined} id={undefined} error={undefined} defaultValue={item.MaximumValue} onChange={(e) => priceUpdate(item, e.target.value, Model.Id, "maxValue")} />
                                                                </div>
                                                            </div>
                                                            <div className='d-flex'>
                                                                <h6 color="warning" className="mt-1">Display For Sale</h6>&nbsp;
                                                                <CustomCheckBox type='checkbox' defaultChecked={item.DisplayInList} onChange={(e) => changeDisplyList(item, e.target.checked)} label={undefined} id={undefined} error={undefined}></CustomCheckBox>
                                                            </div>
                                                            {/* <div className='row pt-3'> */}
                                                            <div className="col-12 text-start">
                                                                <CustomDatePicker label={'Start Date'} defaultValue={moment(item.StartDate).format("YYYY-MM-DD")} onChange={(e) => handleStartDateChange(e, item)} id={undefined} error={undefined} />
                                                            </div>
                                                            {/* </div> */}
                                                            {/* <div className='row pt-3'> */}
                                                            <div className="col-12 text-start">
                                                                <CustomDatePicker label={'End Date'} defaultValue={moment(item.EndDate).format("YYYY-MM-DD")} onChange={(e) => handleEndDateChange(e, item)} id={undefined} error={undefined} />
                                                            </div>
                                                            {/* </div> */}
                                                            <div className='d-flex pt-3'>
                                                                <h6 color="warning" className="mt-1">Restricted Low End Model</h6>&nbsp;
                                                                <CustomCheckBox type='checkbox' defaultChecked={item.IsRestricted} onChange={(e) => changeRestrictedStatus(item, e.target.checked)} label={undefined} id={undefined} error={undefined}></CustomCheckBox>
                                                            </div>
                                                        </Card>
                                                        :
                                                        <Card color="#eee" className='p-2'>
                                                            <CardHeader color="light">
                                                                {item.Name}
                                                            </CardHeader>
                                                            <div className='row pt-3'>
                                                                <div className="col-7 text-start">
                                                                    <h6 className='mt-2'>AED MIN</h6>
                                                                </div>
                                                                <div className="col-5 text-end">
                                                                    <CustomTextBox type={"number"} label={undefined} id={undefined} error={undefined} defaultValue={item.MinimumValue} onChange={(e) => priceUpdate(item, e.target.value, Model.Id, "minValue")} />
                                                                </div>
                                                            </div>
                                                            <div className='row pt-3'>
                                                                <div className="col-7 text-start">
                                                                    <h6 className='mt-2'>AED MAX</h6>
                                                                </div>
                                                                <div className="col-5 text-end">
                                                                    <CustomTextBox type={"number"} label={undefined} id={undefined} error={undefined} defaultValue={item.MaximumValue} onChange={(e) => priceUpdate(item, e.target.value, Model.Id, "maxValue")} />
                                                                </div>
                                                            </div>
                                                            <div className='d-flex'>
                                                                <h6 color="warning" className="mt-1">Display For Sale</h6>&nbsp;
                                                                <CustomCheckBox type='checkbox' defaultChecked={item.DisplayInList} onChange={(e) => changeDisplyList(item, e.target.checked)} label={undefined} id={undefined} error={undefined}></CustomCheckBox>
                                                            </div>
                                                            <div className='row pt-3'>
                                                                <div className="col-12 text-start">
                                                                    <CustomDatePicker label={'Start Date'} defaultValue={moment(item.StartDate).format("YYYY-MM-DD")} onChange={(e) => handleStartDateChange(e, item)} id={undefined} error={undefined} />
                                                                </div>
                                                            </div>
                                                            <div className='row pt-3'>
                                                                <div className="col-12 text-start">
                                                                    <CustomDatePicker label={'End Date'} defaultValue={moment(item.EndDate).format("YYYY-MM-DD")} onChange={(e) => handleEndDateChange(e, item)} id={undefined} error={undefined} />
                                                                </div>
                                                            </div>
                                                            <div className='d-flex'>
                                                                <h6 color="warning" className="mt-1">Restricted Low End Model</h6>&nbsp;
                                                                <CustomCheckBox type='checkbox' defaultChecked={item.IsRestricted} onChange={(e) => changeRestrictedStatus(item, e.target.checked)} label={undefined} id={undefined} error={undefined}></CustomCheckBox>
                                                            </div>
                                                        </Card>
                                                    }
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                    <Row>
                                        <CustomToaster message={"Minimum and Maximum value should not be Empty"} color={'text-danger'} toast={showToastPrice} setToast={setShowToastPrice} />
                                        <CustomToaster message={"Maximum value should be greater than the Minimum value"} color={'text-danger'} toast={showToast} setToast={setShowToast} />
                                    </Row>
                                </ModalBody>
                                <ModalFooter>
                                    <Col xs="12" className="text-end">
                                        <Button color="danger" onClick={() => getData()}>Close</Button>
                                        <Button color="success" className='mx-2' onClick={() => UpdateModelVarients(BrandId)} >Save</Button>
                                    </Col>
                                </ModalFooter>
                            </Modal>
                        )
                    })}
                </Row>
            </Container >
        </div >
    )
}

export default ProductValue